import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from 'xlsx';
import "./IBCommissionHistory.css";

const IBCommissionHistory = () => {
  const [commissionData, setCommissionData] = useState([]);
  const [loading, setLoading] = useState(false);

  const FETCH_API = "https://server.account.majestyfx.com/admin_ib_commission_history.php";

  useEffect(() => {
    fetchCommissionHistory();
  }, []);

  const fetchCommissionHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(FETCH_API);
      if (response.data.status) {
        setCommissionData(response.data.data || []);
      } else {
        alert("Failed to fetch IB commission history");
      }
    } catch (error) {
      console.error("Error fetching IB commission history:", error);
      alert("Error fetching IB commission history. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = () => {
    if (commissionData.length === 0) {
      alert('No data to export');
      return;
    }

    const exportData = commissionData.map((item) => ({
      'ID': item.id,
      'IB Email': item.ib_email,
      'Total Commission': parseFloat(item.total_commission).toFixed(2),
      'Available Commission': parseFloat(item.available_commission).toFixed(2),
      'Last Updated': new Date(item.updated_at).toLocaleString()
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'IB Commission History');
    XLSX.writeFile(wb, `IB_Commission_History_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  return (
    <div className="ib-commission-history-page">
      <div className="page-header">
        <h1>IB Commission History</h1>
        <div>
          <button
            className="refresh-btn"
            onClick={fetchCommissionHistory}
            disabled={loading}
          >
            <i className="fas fa-sync-alt"></i> Refresh
          </button>
          <button
            className="excel-btn"
            onClick={exportToExcel}
            disabled={loading || commissionData.length === 0}
            style={{ marginLeft: '10px', backgroundColor: '#28a745', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            <i className="fas fa-file-excel"></i> Export to Excel
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading-spinner">
          <i className="fas fa-spinner fa-spin"></i> Loading...
        </div>
      ) : (
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>IB Email</th>
                <th>Total Commission</th>
                <th>Available Commission</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {commissionData.length > 0 ? (
                commissionData.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.ib_email}</td>
                    <td className="amount">${parseFloat(item.total_commission).toFixed(2)}</td>
                    <td className="amount available">${parseFloat(item.available_commission).toFixed(2)}</td>
                    <td>{new Date(item.updated_at).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-data">
                    No commission history found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default IBCommissionHistory;

